import React from 'react';
import 'twin.macro';
import Button from 'components/Buttons/Button';
import { ArrowPathIcon as Refresh } from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';

export function ApplicationVersion() {
  const { t } = useTranslation(['userSettings']);
  return (
    <div tw="text-right text-muted">
      {t('userSettings:account.applicationVersion')} : {__APP_VERSION__}
      {(window as any).swUpdate ? (
        <div tw="mt-2">
          <Button
            small
            icon={Refresh}
            onClick={() => (window as any).location.reload(true)}
          >
            {t('userSettings:account.updateApplicationVersion')}
          </Button>
        </div>
      ) : (
        <div tw="text-sm font-medium text-positive-moderate">
          {t('userSettings:account.applicationVersionUpToDate')}
        </div>
      )}
    </div>
  );
}
